import React, {Component} from 'react';
import './App.scss';

// Images
import TwitterLogo from '../assets/images/twitterLogo.png';
import TuringLogo from '../assets/images/turingLogo.png';

// UI components
import TweetsContainer from './views/tweetsContainer/TweetsContainer';
import ConfigurationPanel from './views/configurationPanel/ConfigurationPanel';

// Context
import ThemeContext from '../contexts/ThemeContext';

// Utils & misc
import { getValueFromLocalStorage, setValueInLocalStorage} from "../utils/utils";

class App extends Component {

	state = {
		isConfigPanelOpen:  false,
		isDarkTheme: getValueFromLocalStorage('isDarkTheme') === "true",
		tweetsConfigs: (function () {
			let defaultValues =  [
				{
					twitterUser: "makeschool",
					maxTweets: 30,
					display: true
				},
				{
					twitterUser: "newsycombinator",
					maxTweets: 30,
					display: true
				},
				{
					twitterUser: "ycombinator",
					maxTweets: 30,
					display: true
				}
			];
			try {
				return JSON.parse(getValueFromLocalStorage('tweetsConfigs')) || defaultValues
			} catch(e){
				return defaultValues;
			}
		})()
	};

	onDarkThemeToggle = (newValue) => {
		this.setState({
			isDarkTheme: newValue
		});
		setValueInLocalStorage('isDarkTheme', newValue)
	};

	onTweetConfigChange = (tweetsConfigs) => {
		this.setState({tweetsConfigs});
		setValueInLocalStorage('tweetsConfigs', JSON.stringify(tweetsConfigs))
	};

	render() {
		return (
			<ThemeContext.Provider value={{isDarkTheme : this.state.isDarkTheme}}>
				<div className={`App ${this.state.isDarkTheme ? 'App--dark' : ''}`}>
					<header className="header">
						<button
							className={`burger ${this.state.isConfigPanelOpen ? 'burger--open' : ''}`}
							onClick={() => {
								this.setState({isConfigPanelOpen: !this.state.isConfigPanelOpen})
							}}
						/>
						<img src={TwitterLogo} className="header__logo" alt="logo Twitter"/>
					</header>

					<ConfigurationPanel
						isOpen={this.state.isConfigPanelOpen}
						onDarkThemeToggle={this.onDarkThemeToggle}
						tweetsConfig={this.state.tweetsConfigs}
						onTweetConfigChange={this.onTweetConfigChange}
					/>

					<div className="tweets">
						{
							this.state.tweetsConfigs.map((tweetData, index) => {
								if( tweetData.display === true)
									return (
										<div className="tweets__box" key={index}>
											<TweetsContainer
												{...tweetData}
											/>
										</div>
									);
								else
									return null;
							})
						}
					</div>
				</div>
			</ThemeContext.Provider>
		);
	}
}

export default App;
